import axios from 'axios';
import { _isAuthenticated, _refreshToken, _showAlert } from './index';
import { _checkValidAuthenticate } from './AuthUtils';

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/v1/admin',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
axiosServices.interceptors.request.use(
  async (config) => {
    await _checkValidAuthenticate();
    const { tokens } = _isAuthenticated();

    if (tokens?.accessToken) {
      config.headers['authorization'] = tokens.accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosServices.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Handle different error status codes
    if (error.response) {
      if (error.response.data?.code === 'PASSWORD_DECRYPTION_FAILED') {
        return Promise.reject(error);
      }
      switch (error.response.status) {
        case 404:
          _showAlert('Service Not Found', 'error');
          return Promise.reject({
            code: error.response.status,
            error: 'Service Not Found'
          });

        case 500:
          _showAlert('500 Internal Server Error', 'error');
          return Promise.reject({
            code: error.response.status,
            error: '500 Internal Server Error'
          });

        case 403:
          _refreshToken();
          _showAlert('Please wait.. Regenerating access token', 'error', 10000);
          return Promise.reject({
            code: error.response.status,
            error: 'Authorizaton Error: Session time out please login again'
          });

        case 401:
          if (!originalRequest._retry) {
            originalRequest._retry = true;
            try {
              await _refreshToken();
              const { tokens } = _isAuthenticated();
              if (tokens?.accessToken) {
                originalRequest.headers['authorization'] = tokens.accessToken;
                return axiosServices(originalRequest);
              }
            } catch (refreshError) {
              sessionStorage.removeItem('authData');
              sessionStorage.removeItem('expirationtime');
              window.location.href = '/?authFailed=true';
              return Promise.reject(refreshError);
            }
          }
          break;

        default:
          _showAlert('Something went wrong on service request or data provided by you. Please check your network and system.', 'error');
          return Promise.reject({
            code: error.response.status,
            status: false,
            response: error.response,
            error: 'Something went wrong on service request or data provided by you. Please check your network and system.'
          });
      }
    }

    return Promise.reject(error);
  }
);

// ==============================|| FETCHER ||============================== //
export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.get(url, { ...config });
  return res.data;
};

export const fetcherPost = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.post(url, { ...config });
  return res.data;
};

export const fetcherPut = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.put(url, { ...config });
  return res.data;
};

export const fetcherDelete = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.delete(url, { ...config });
  return res.data;
};
